var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgChevronLeft(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M13.7071 8.29199C13.5182 8.10519 13.2632 8.00041 12.9976 8.00041C12.7319 8.00041 12.477 8.10519 12.2881 8.29199L9.32306 11.231C9.10806 11.449 9.00106 11.731 9.00106 12.01C9.00106 12.289 9.10806 12.566 9.32306 12.779L12.2781 15.709C12.4671 15.8956 12.722 16.0002 12.9876 16.0002C13.2531 16.0002 13.508 15.8956 13.6971 15.709C13.7902 15.6172 13.8642 15.5077 13.9147 15.387C13.9653 15.2663 13.9913 15.1368 13.9913 15.006C13.9913 14.8752 13.9653 14.7456 13.9147 14.625C13.8642 14.5043 13.7902 14.3948 13.6971 14.303L11.3801 12.005L13.7071 9.69799C13.7999 9.60596 13.8736 9.49645 13.9238 9.37579C13.9741 9.25513 14 9.12571 14 8.99499C14 8.86428 13.9741 8.73485 13.9238 8.6142C13.8736 8.49354 13.7999 8.38403 13.7071 8.29199Z",
    fill: "currentColor"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgChevronLeft);
export default __webpack_public_path__ + "static/media/chevron-left.188dd8d4.svg";
export { ForwardRef as ReactComponent };